import { useResourceRoute } from 'json-api-hooks';
import React, { FC } from 'react';

import { Section } from '../components/App/typescript';
import Detail from '../components/Detail';
import { LoadingDetail } from '../components/Loading';
import emoji from '../lib/emoji';
import { DepartmentResource } from '../models';

const DepartmentDetail: FC<{ department?: DepartmentResource }> = ({ department }) => {
  const route = useResourceRoute(department);

  if (!department) {
    return <LoadingDetail />;
  }

  return (
    <Detail
      text={emoji(`🌍 ${department.attributes.name}`)}
      url={GLOBALS.section === Section.Admin ? route : undefined}
    />
  );
};

export default DepartmentDetail;
